<template>
  <b-modal
    id="ticket-transfer-modal"
    size="lg" 
    class="vh-100" 
    :ok-title="trans('transfer')"
    @ok.prevent="transferTicket"
    :ok-disabled="!isEmailValid"
  >
    <template #modal-title>
      {{ trans('transfer_ticket') }}
      <small>#{{ ticket.id }} #{{ticket.recipient_id}}</small>
    </template>
    <b-row v-if="isAdminTransfer" class="mb-2">
      <b-col>
        <b-button variant="outline-primary" v-b-modal.ticket-transfer-admin-choose-client-modal :disabled="busy">
          {{ trans('choose_a_client') }}
        </b-button>
      </b-col>
    </b-row>
    <template v-if="ticket">
      <b-row>
        <b-col class="col-6">
          <b-form-group :label="trans('first_name')">
            <b-form-input v-model="first_name"/>
          </b-form-group>
        </b-col>
        <b-col class="col-6">
          <b-form-group :label="trans('last_name')">
            <b-form-input v-model="last_name"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <b-form-group :label="trans('email')">
            <b-form-input 
            v-model="email"
            :state="isEmailValid"
            :disabled="busy"
            required/>
          </b-form-group>
        </b-col>
        <b-col v-if="isAdminTransfer">
          <b-form-group :label="trans('send_email_with_ticket')">
            <b-checkbox v-model="send_email" switch>
              {{ trans(send_email ? 'yes' : 'no') }}
            </b-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
    </template>
    <p v-if="busy" class="mt-4">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
    <admin-choose-client-modal
      id="ticket-transfer-admin-choose-client-modal"
      :organization="organization"
      @chosen="onChooseClient"
    ></admin-choose-client-modal>
    <b-row>
      <b-col class="col-12 col-lg-8">
        <ticket-small
          :organization="organization"
          :ticket="ticket"
        ></ticket-small>
      </b-col>
    </b-row>
  </b-modal>
</template>
  
<script>
  import TicketSmall from '../ticket/TicketSmall'
  import AdminChooseClientModal from '../client/AdminChooseClientModal'

  export default {
    props: {
      organization: Object,
      ticket: {
        type: Object,
        default: null
      },
      isAdminTransfer: {
        type: Boolean,
        default: false
      }
    },
    components: {
      AdminChooseClientModal,
      TicketSmall
    },
    data() {
      return {
        trans: trans,
        lang: lang,
        error: null,
        busy: false,
        email: '',
        first_name: '',
        last_name: '',
        send_email: true,
      }
    },
    computed: {
      isEmailValid() {
        return _.validateEmail(this.email)
      },
    },
    methods: {
      onShown() {
        this.first_name = ''
        this.last_name = ''
        this.email = ''
      },
      onChooseClient(client) {
        this.first_name = client.first_name
        this.last_name = client.last_name
        this.email = client.email
      },
      transferTicket() {
        this.busy = true
        this.error = null

        let url = this.isAdminTransfer ?
           `/organization/${this.organization.id}/ticket/${this.ticket.id}/transfer` :
           `/org/${this.organization.id}/ticket/${this.ticket.id}/transfer`

        const data = {
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          is_client: !this.isAdminTransfer,
        }
        axios.post(url, data)
        .then(response => {
          this.busy = false
          this.$emit('transfered', { send_email: this.send_email, ticket: response.data })
          this.$bvModal.hide('ticket-transfer-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.ticketTransferModal = this
    }
  }
</script>
  